export const Options = {
    body: {
        items: [],
        errors: []
    }
};
